import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ResultsService {

  private NetTestOrMobInfoSource: BehaviorSubject<any> = new BehaviorSubject({ RsltTypeSwitch: true, selectedNetTestIndex: [0,1,2,3,4,5,6,7,8], selectedMobInfoIndex: [0,1,2] });
  NetTestOrMobInfo = this.NetTestOrMobInfoSource.asObservable();

  private NetTestOrMobInfoSourceByID: BehaviorSubject<number> = new BehaviorSubject(-1);
  NetTestOrMobInfoByID = this.NetTestOrMobInfoSourceByID.asObservable();

  constructor() { }

  //Filtered columns details used in Synopsis
  setNetTestOrMobInfo(data) {
    this.NetTestOrMobInfoSource.next(data);
  }

  //Passing single index of selected rslt type of nettest or mobile info
  setNetTestOrMobInfoByID(data: number) {
    this.NetTestOrMobInfoSourceByID.next(data);
  }
}
